import { useEffect } from 'react';
import styled from 'styled-components';
import { useOutlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { HubTopNav } from '@prosolve/common-components-ui'
import useMediaQuery from '../hooks/useMediaQuery';
import useMe from '../hooks/useMe';
import LeftNav from './LeftNav';
import Jobs from './Jobs/Jobs';
//import ProsolveLogo from '../images/prosolve-logo-slim.png';
import { rootPrefix } from '../utils/utils';

const Container = styled.div`
  display: flex;
  height: calc(100vh - 40px);
  width: 100%;
`

const OutletWrapper = styled.div`
  flex: 1;
  margin-left: ${props => props.$isMobileView ? '0px' : '240px' };
  margin-top: 39px;
`

export default () => {

  // Modify default mobile view determination to match Quest and SLED portal which had left nav on 
  // material UI Hidden tag property "lgUp" which anything 1280 and up is desktop, and below 1280 mobile
  const isMobileView = useMediaQuery('(max-width: 1280px)');

  const me = useMe()
  
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    /*if (pathname === '/') {
      navigate(`${rootPrefix}/classes`)
    }*/
  }, [pathname, navigate])

  const outlet = useOutlet()

  const appRootPath = rootPrefix

  /*const appLogo = (
    <img
      src={ProsolveLogo}
      style={{ height: '34px', marginRight: '20px', cursor: 'pointer' }}
      alt="prosolveLogo"
      onClick={() => navigate(appRootPath)}
    />
  )*/

  return (
    <>
      <HubTopNav 
        isMobileView={isMobileView}
        // THEME SELECTION DISABLED — remove isHideTheme to re-enable the theme dropdown (see src/Theme.js)
        isHideTheme={true}
        MobileDrawerNav={LeftNav}
        navigate={navigate}
        appRootPath={appRootPath}
        //appLogo={appLogo}
        me={me}
      />
      <Container>
        {
          !isMobileView &&
          <LeftNav isMobileView={isMobileView} appRootPath={appRootPath} />
        }
        <OutletWrapper $isMobileView={isMobileView}>
          {outlet || <Jobs />}
        </OutletWrapper>
      </Container>
    </>
  )
}
